/* Quartosenso Parfum — script del tema (vanilla JS, nessuna dipendenza) */
(function () {
  'use strict';

  var QS = window.QS || {};
  var root = (QS.routes && QS.routes.root) || '/';
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var debounce = function (fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; };
  var store = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  };
  var parseHTML = function (html) { return new DOMParser().parseFromString(html, 'text/html'); };
  var sectionInner = function (html) {
    var doc = parseHTML(html);
    var s = doc.querySelector('.shopify-section');
    return s ? s : doc.body;
  };

  /* ------------------------------------------------------------------
     Header: altezza, stato scorrimento, trasparenza
  ------------------------------------------------------------------ */
  var HeaderRoot = function () { return Reflect.construct(HTMLElement, [], HeaderRoot); };
  HeaderRoot.prototype = Object.create(HTMLElement.prototype);
  HeaderRoot.prototype.connectedCallback = function () {
    var self = this;
    var main = document.getElementById('MainContent');
    var first = main && main.querySelector('.shopify-section');
    if (this.classList.contains('is-transparent') && !(first && first.querySelector('[data-first-section]'))) {
      this.classList.remove('is-transparent');
    }
    var measure = function () {
      var h = self.offsetHeight;
      document.documentElement.style.setProperty('--header-h', h + 'px');
      document.documentElement.style.setProperty('--sticky-offset', (self.classList.contains('is-sticky') || self.classList.contains('is-transparent') ? h : 0) + 'px');
    };
    measure();
    window.addEventListener('resize', debounce(measure, 150));
    // Barra annunci sopra l'header trasparente: l'header parte sotto la barra e sale mentre la barra esce dallo schermo
    var ann = document.querySelector('.announce');
    var annH = 0;
    var measureAnn = function () { annH = ann && ann.offsetParent !== null ? ann.offsetHeight : 0; };
    measureAnn();
    window.addEventListener('resize', debounce(function () { measureAnn(); onScroll(); }, 150));
    var onScroll = function () {
      var y = window.scrollY;
      self.classList.toggle('is-scrolled', y > 40);
      if (self.classList.contains('is-transparent')) {
        var off = Math.max(0, annH - y);
        self.style.top = off + 'px';
      }
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  };
  Object.setPrototypeOf(HeaderRoot, HTMLElement);
  if (!customElements.get('header-root')) customElements.define('header-root', HeaderRoot);

  /* ------------------------------------------------------------------
     Pannelli (menu, carrello, ricerca, filtri)
  ------------------------------------------------------------------ */
  var Drawers = {
    current: null,
    lastFocus: null,
    veil: function () { return $('[data-veil]'); },
    open: function (name) {
      var el = $('[data-drawer="' + name + '"]');
      if (!el) return false;
      if (this.current && this.current !== el) this.close(true);
      this.lastFocus = document.activeElement;
      el.hidden = false;
      var veil = this.veil();
      if (veil) { veil.hidden = false; }
      requestAnimationFrame(function () {
        el.classList.add('is-open');
        if (veil) veil.classList.add('is-visible');
      });
      document.documentElement.style.overflow = 'hidden';
      this.current = el;
      var focusable = el.querySelector('input[type="search"], [data-drawer-close], a, button');
      if (focusable) setTimeout(function () { focusable.focus({ preventScroll: true }); }, 60);
      return true;
    },
    close: function (instant) {
      var el = this.current;
      if (!el) return;
      el.classList.remove('is-open');
      var veil = this.veil();
      if (veil) veil.classList.remove('is-visible');
      var keepVisible = el.classList.contains('facets-wrap--sidebar') && window.matchMedia('(min-width: 990px)').matches;
      setTimeout(function () {
        if (!el.classList.contains('is-open') && el.dataset.drawer !== 'filters') el.hidden = true;
        if (veil && !veil.classList.contains('is-visible')) veil.hidden = true;
      }, instant ? 0 : 350);
      if (keepVisible) el.hidden = false;
      document.documentElement.style.overflow = '';
      this.current = null;
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
    }
  };
  QS.drawers = Drawers;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var name = opener.getAttribute('data-drawer-open');
      if (name === 'cart' && QS.cartType !== 'drawer') return;
      if (Drawers.open(name)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target.matches('[data-veil]')) {
      e.preventDefault();
      Drawers.close();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      Drawers.close();
    }
  });

  /* ------------------------------------------------------------------
     Carrello AJAX
  ------------------------------------------------------------------ */
  var Cart = {
    sectionIds: function () {
      var ids = [];
      if ($('#CartDrawer')) ids.push('cart-drawer');
      var page = $('[data-cart-page]');
      if (page) ids.push(page.getAttribute('data-section'));
      return ids;
    },
    render: function (sections) {
      if (!sections) return;
      Object.keys(sections).forEach(function (id) {
        var html = sections[id];
        if (!html) return;
        var fresh = sectionInner(html);
        if (id === 'cart-drawer') {
          var cur = $('#CartDrawer [data-cart-root]');
          var next = fresh.querySelector('[data-cart-root]');
          if (cur && next) cur.innerHTML = next.innerHTML;
          var cnt = fresh.querySelector('[data-cart-count]');
          if (cnt) Cart.setCount(parseInt(cnt.textContent, 10) || 0);
        } else {
          var page = $('[data-cart-page]');
          var nextPage = fresh.querySelector('[data-cart-page]');
          if (page && nextPage) page.innerHTML = nextPage.innerHTML;
        }
      });
    },
    setCount: function (n) {
      $$('[data-cart-count-badge]').forEach(function (b) {
        b.textContent = n;
        b.classList.toggle('is-empty', n === 0);
      });
    },
    refresh: function () {
      var ids = this.sectionIds();
      if (!ids.length) {
        return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { Cart.setCount(c.item_count); });
      }
      return fetch(root + '?sections=' + ids.join(','))
        .then(function (r) { return r.json(); })
        .then(function (s) { Cart.render(s); });
    },
    afterAdd: function () {
      if (QS.cartType === 'drawer' && $('#CartDrawer')) {
        return Cart.refresh().then(function () { Drawers.open('cart'); });
      }
      window.location.href = (QS.routes && QS.routes.cart) || '/cart';
    },
    change: function (line, qty) {
      var drawer = $('#CartDrawer');
      if (drawer) drawer.classList.add('is-loading');
      return fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty, sections: Cart.sectionIds() })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status && res.description) { window.alert(res.description); return Cart.refresh(); }
          Cart.render(res.sections);
          Cart.setCount(res.item_count);
        })
        .finally(function () { if (drawer) drawer.classList.remove('is-loading'); });
    }
  };
  QS.cart = Cart;

  // invio dei moduli prodotto
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-product-form]')) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add-button]');
    var err = form.querySelector('[data-form-error]');
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    if (err) err.hidden = true;
    var fd = new FormData(form);
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          if (err) { err.textContent = res.body.description || res.body.message || QS.strings.cartError; err.hidden = false; }
          return;
        }
        document.dispatchEvent(new CustomEvent('qs:cart-added', { detail: res.body }));
        return Cart.afterAdd();
      })
      .catch(function () { if (err) { err.textContent = QS.strings.cartError; err.hidden = false; } })
      .finally(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } });
  });

  // aggiornamenti da altri script (es. Fragrance Finder)
  document.addEventListener('cart:build', function () { Cart.afterAdd(); });
  document.addEventListener('cart:refresh', function () { Cart.refresh(); });

  // quantità e rimozione nelle righe del carrello
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (step) {
      var wrap = step.closest('[data-qty]');
      var input = wrap && wrap.querySelector('input');
      if (!input) return;
      var min = parseInt(input.min || '0', 10);
      var v = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-qty-step'), 10));
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var rm = e.target.closest('[data-line-remove]');
    if (rm) { e.preventDefault(); Cart.change(parseInt(rm.getAttribute('data-line-remove'), 10), 0); }
  });
  var lineChange = debounce(function (input) {
    Cart.change(parseInt(input.getAttribute('data-line-qty'), 10), Math.max(0, parseInt(input.value, 10) || 0));
  }, 350);
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-line-qty]')) lineChange(t);
    if (t.matches('[data-cart-note]')) {
      fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: t.value }) });
    }
    if (t.matches('[data-autosubmit]')) t.form.submit();
  });

  /* ------------------------------------------------------------------
     Ricerca istantanea
  ------------------------------------------------------------------ */
  (function () {
    var input = $('[data-predictive-input]');
    var out = $('[data-predictive-results]');
    if (!input || !out || input.hasAttribute('data-predictive-off')) return;
    var ctrl;
    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var url = QS.routes.search + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page,article&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search';
      fetch(url, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) { out.innerHTML = sectionInner(html).innerHTML; })
        .catch(function () {});
    }, 250);
    input.addEventListener('input', run);
  })();

  /* ------------------------------------------------------------------
     Parallasse leggera
  ------------------------------------------------------------------ */
  var Parallax = {
    items: [],
    reduce: window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    add: function (box, imgs) {
      if (this.reduce) return;
      this.items.push({ box: box, imgs: imgs });
      if (this.items.length === 1) {
        var self = this;
        window.addEventListener('scroll', function () { requestAnimationFrame(self.update.bind(self)); }, { passive: true });
      }
      this.update();
    },
    update: function () {
      var vh = window.innerHeight;
      this.items.forEach(function (it) {
        var r = it.box.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var p = (r.top + r.height / 2 - vh / 2) / (vh + r.height);
        var y = (-p * r.height * 0.18).toFixed(1) + 'px';
        it.imgs.forEach(function (img) { img.style.setProperty('--py', y); });
      });
    }
  };
  /* ------------------------------------------------------------------
     Hero editoriale: lettere che emergono dalla sfocatura, riflesso di luce,
     particelle dorate e lieve parallasse col mouse
  ------------------------------------------------------------------ */
  var HeroBanner = function () { return Reflect.construct(HTMLElement, [], HeroBanner); };
  HeroBanner.prototype = Object.create(HTMLElement.prototype);
  HeroBanner.prototype.connectedCallback = function () {
    var self = this;
    if (this._init) return; this._init = true;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // divide i titoli in lettere (parole intere non spezzate a capo)
    var offset = 0;
    $$('[data-hero-split]', this).forEach(function (line, li) {
      var text = line.textContent;
      line.setAttribute('aria-label', text);
      line.textContent = '';
      text.split(/(\s+)/).forEach(function (word) {
        if (!word) return;
        if (/^\s+$/.test(word)) { line.appendChild(document.createTextNode(' ')); return; }
        var w = document.createElement('span');
        w.style.display = 'inline-block'; w.style.whiteSpace = 'nowrap';
        w.setAttribute('aria-hidden', 'true');
        Array.prototype.forEach.call(word, function (ch) {
          var c = document.createElement('span');
          c.className = 'hero__char'; c.textContent = ch;
          c.style.setProperty('--ci', offset++);
          c.style.setProperty('--ld', (li * 250) + 'ms');
          w.appendChild(c);
        });
        line.appendChild(w);
      });
    });
    var start = function () {
      requestAnimationFrame(function () { self.classList.add('is-ready'); });
      if (!reduce) setTimeout(function () { self.classList.add('is-shine'); }, offset * 55 + 1500);
    };
    var img = this.querySelector('.hero__img');
    if (img && !img.complete) { img.addEventListener('load', start, { once: true }); setTimeout(start, 1200); } else start();

    // parallasse col mouse
    if (this.dataset.parallax === 'true' && !reduce && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      this.addEventListener('mousemove', function (e) {
        var r = self.getBoundingClientRect();
        self.style.setProperty('--mx', ((e.clientX - r.left) / r.width - .5) * -22 + 'px');
        self.style.setProperty('--my', ((e.clientY - r.top) / r.height - .5) * -14 + 'px');
      });
      this.addEventListener('mouseleave', function () { self.style.setProperty('--mx', '0px'); self.style.setProperty('--my', '0px'); });
    }

    // scorrimento morbido alla sezione successiva
    var cue = this.querySelector('[data-hero-scroll]');
    if (cue) cue.addEventListener('click', function (e) {
      e.preventDefault();
      var next = self.closest('.shopify-section');
      next = next && next.nextElementSibling;
      window.scrollTo({ top: next ? next.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sticky-offset'), 10) || 0) + 1 : window.innerHeight, behavior: 'smooth' });
    });

    // particelle dorate che salgono come una scia di profumo
    var cv = this.querySelector('[data-hero-particles]');
    if (!cv || reduce) return;
    var ctx = cv.getContext('2d'), dpr = Math.min(2, window.devicePixelRatio || 1), W = 0, H = 0, parts = [], raf = null, visible = true;
    var accent = getComputedStyle(this).getPropertyValue('--hero-accent').trim() || '#d9b779';
    var size = function () { W = cv.clientWidth; H = cv.clientHeight; cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); };
    // intensità regolabile dall'editor (10-100%)
    var level = Math.max(.1, Math.min(1, (parseInt(cv.getAttribute('data-level'), 10) || 60) / 100));
    var count = Math.round((window.innerWidth < 750 ? 30 : 60) * (.6 + level * .6));
    // piccola sfera luminosa pre-disegnata: alone morbido senza costi di calcolo
    var sprite = document.createElement('canvas'), SP = 64;
    sprite.width = sprite.height = SP;
    var sc = sprite.getContext('2d'), g = sc.createRadialGradient(SP / 2, SP / 2, 0, SP / 2, SP / 2, SP / 2);
    sc.fillStyle = accent; var hex = sc.fillStyle; // normalizza il colore in #rrggbb
    var rgb = /^#([0-9a-f]{6})$/i.test(hex) ? [1, 3, 5].map(function (k) { return parseInt(hex.substr(k, 2), 16); }) : [217, 183, 121];
    var rgba = function (al) { return 'rgba(' + rgb.join(',') + ',' + al + ')'; };
    g.addColorStop(0, 'rgba(255,255,255,1)'); g.addColorStop(.18, rgba(1)); g.addColorStop(.45, rgba(.33)); g.addColorStop(1, rgba(0));
    sc.fillStyle = g; sc.fillRect(0, 0, SP, SP);
    var spawn = function (p, anywhere) {
      p.x = Math.random() * W; p.y = anywhere ? Math.random() * H : H + 20;
      p.big = Math.random() < .12;                               // qualche bokeh più grande e morbido
      p.r = (p.big ? Math.random() * 4 + 4 : Math.random() * 2.4 + 1.4) * (.75 + level * .5);
      p.v = (p.big ? Math.random() * .2 + .08 : Math.random() * .45 + .18);
      p.a = (p.big ? Math.random() * .25 + .2 : Math.random() * .4 + .6) * (.5 + level * .5);
      p.ph = Math.random() * Math.PI * 2; p.sw = Math.random() * .7 + .25; return p;
    };
    size();
    for (var i = 0; i < count; i++) parts.push(spawn({}, true));
    var tick = function (t) {
      ctx.clearRect(0, 0, W, H);
      ctx.globalCompositeOperation = 'lighter';
      parts.forEach(function (p) {
        p.y -= p.v; p.x += Math.sin(t / 1700 + p.ph) * p.sw * .4;
        if (p.y < -20) spawn(p, false);
        var fade = Math.min(1, p.y / (H * .3)) * Math.min(1, (H - p.y + 20) / 80);
        var tw = .65 + .35 * Math.sin(t / 650 + p.ph);           // scintillio
        ctx.globalAlpha = Math.max(0, p.a * fade * tw);
        var d = p.r * (p.big ? 7 : 8);
        ctx.drawImage(sprite, p.x - d / 2, p.y - d / 2, d, d);
      });
      raf = visible ? requestAnimationFrame(tick) : null;
    };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible && !raf) raf = requestAnimationFrame(tick); }).observe(this);
    }
    raf = requestAnimationFrame(tick);
    window.addEventListener('resize', debounce(size, 200));
  };
  Object.setPrototypeOf(HeroBanner, HTMLElement);
  if (!customElements.get('hero-banner')) customElements.define('hero-banner', HeroBanner);

  /* ------------------------------------------------------------------
     Slideshow
  ------------------------------------------------------------------ */
  var SlideShow = function () { return Reflect.construct(HTMLElement, [], SlideShow); };
  SlideShow.prototype = Object.create(HTMLElement.prototype);
  SlideShow.prototype.connectedCallback = function () {
    var self = this;
    this.slides = $$('[data-slide]', this);
    this.dots = $$('[data-goto]', this);
    this.index = 0;
    this.dots.forEach(function (d) { d.addEventListener('click', function () { self.go(parseInt(d.getAttribute('data-goto'), 10)); self.restart(); }); });
    if (this.slides.length > 1 && this.dataset.autoplay === 'true') {
      this.restart();
      this.addEventListener('mouseenter', function () { clearInterval(self.timer); });
      this.addEventListener('mouseleave', function () { self.restart(); });
    }
    // scorrimento con il dito
    var x0 = null;
    this.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    this.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 50) { self.go(self.index + (dx < 0 ? 1 : -1)); self.restart(); }
      x0 = null;
    });
    if (this.classList.contains('has-parallax')) Parallax.add(this, $$('.slide__img', this));
  };
  SlideShow.prototype.restart = function () {
    var self = this;
    clearInterval(this.timer);
    if (this.slides.length > 1 && this.dataset.autoplay === 'true') {
      this.timer = setInterval(function () { self.go(self.index + 1); }, parseInt(this.dataset.speed, 10) || 5000);
    }
  };
  SlideShow.prototype.go = function (i) {
    var n = this.slides.length;
    if (!n) return;
    this.index = (i + n) % n;
    var idx = this.index;
    this.slides.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); });
    this.dots.forEach(function (d, k) { d.classList.toggle('is-active', k === idx); });
  };
  Object.setPrototypeOf(SlideShow, HTMLElement);
  if (!customElements.get('slide-show')) customElements.define('slide-show', SlideShow);

  // selezione della slide dall'editor del tema
  document.addEventListener('shopify:block:select', function (e) {
    var show = e.target.closest('slide-show');
    if (show) { var i = Array.prototype.indexOf.call(show.slides || [], e.target); if (i > -1) { clearInterval(show.timer); show.go(i); } }
    var hs = e.target.closest('[data-hotspots]');
    if (hs) activateHotspot(hs, e.target.getAttribute('data-hotspot'));
  });

  $$('.has-parallax [data-parallax]').forEach(function (m) { Parallax.add(m.parentNode, $$('img', m)); });

  /* ------------------------------------------------------------------
     Hotspot
  ------------------------------------------------------------------ */
  function activateHotspot(wrap, id) {
    $$('[data-hotspot]', wrap).forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-hotspot') === id); });
    $$('[data-hotspot-item]', wrap).forEach(function (it) { it.classList.toggle('is-active', it.getAttribute('data-hotspot-item') === id); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hotspot]');
    if (b) activateHotspot(b.closest('[data-hotspots]'), b.getAttribute('data-hotspot'));
  });

  /* ------------------------------------------------------------------
     Galleria prodotto + lightbox
  ------------------------------------------------------------------ */
  var MediaGallery = function () { return Reflect.construct(HTMLElement, [], MediaGallery); };
  MediaGallery.prototype = Object.create(HTMLElement.prototype);
  MediaGallery.prototype.connectedCallback = function () {
    var self = this;
    this.main = $('[data-gallery-main]', this);
    $$('[data-thumb]', this).forEach(function (t) {
      t.addEventListener('click', function () { self.show(t.getAttribute('data-thumb')); });
    });
    // mobile: aggiorna i puntini in base allo scorrimento
    if (this.main) {
      this.main.addEventListener('scroll', debounce(function () {
        if (window.innerWidth >= 990) return;
        var i = Math.round(self.main.scrollLeft / self.main.clientWidth);
        var slide = self.main.children[i];
        if (slide) self.mark(slide.getAttribute('data-media-id'));
      }, 60), { passive: true });
    }
    // lente al passaggio del mouse (solo dispositivi con mouse)
    if (this.dataset.zoom === 'true' && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      $$('.gallery__zoom', this).forEach(function (btn) {
        var img = btn.querySelector('img');
        if (!img) return;
        btn.addEventListener('mouseenter', function () { btn.classList.add('is-lens'); });
        btn.addEventListener('mousemove', function (e) {
          var r = btn.getBoundingClientRect();
          img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        });
        btn.addEventListener('mouseleave', function () { btn.classList.remove('is-lens'); });
      });
    }
    this.addEventListener('click', function (e) {
      var z = e.target.closest('[data-zoom-src]');
      if (!z) return;
      var all = $$('[data-zoom-src]', self);
      Lightbox.open(all.map(function (b) { return b.getAttribute('data-zoom-src'); }), all.indexOf(z), all.map(function (b) { var i = b.querySelector('img'); return i ? (i.currentSrc || i.src) : ''; }));
    });
  };
  MediaGallery.prototype.mark = function (id) {
    $$('[data-media-id]', this).forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-media-id') === String(id)); });
    $$('[data-thumb]', this).forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === String(id)); });
    $$('[data-dot]', this).forEach(function (d) { d.classList.toggle('is-active', d.getAttribute('data-dot') === String(id)); });
  };
  MediaGallery.prototype.show = function (id) {
    if (!id) return;
    this.mark(id);
    var slide = this.main && this.main.querySelector('[data-media-id="' + id + '"]');
    if (slide && window.innerWidth < 990) this.main.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    $$('video', this).forEach(function (v) { if (!v.closest('.is-active')) v.pause(); });
  };
  Object.setPrototypeOf(MediaGallery, HTMLElement);
  if (!customElements.get('media-gallery')) customElements.define('media-gallery', MediaGallery);
  /* Galleria a schermo intero con zoom: click/doppio tap, pizzico, trascinamento, swipe */
  var Lightbox = {
    el: null, i: 0, srcs: [], scale: 1, x: 0, y: 0,
    init: function () {
      var el = this.el = $('[data-lightbox]');
      if (!el || el._ready) return !!el;
      el._ready = true;
      var self = this;
      this.track = $('[data-lb-track]', el);
      el.addEventListener('click', function (e) {
        if (e.target.closest('[data-lb-close]')) return self.close();
        if (e.target.closest('[data-lb-prev]')) return self.go(self.i - 1);
        if (e.target.closest('[data-lb-next]')) return self.go(self.i + 1);
        var t = e.target.closest('[data-lb-thumb]');
        if (t) return self.go(+t.getAttribute('data-lb-thumb'));
      });
      document.addEventListener('keydown', function (e) {
        if (el.hidden) return;
        if (e.key === 'Escape') self.close();
        if (e.key === 'ArrowRight') self.go(self.i + 1);
        if (e.key === 'ArrowLeft') self.go(self.i - 1);
      });
      var stage = $('[data-lb-stage]', el);
      // gesti: un dito = trascina/swipe, due dita = pizzico, tocco/click = zoom
      var pts = {}, start = null, moved = false, lastTap = 0;
      var dist = function () { var p = Object.values(pts); return Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y); };
      stage.addEventListener('pointerdown', function (e) {
        stage.setPointerCapture(e.pointerId);
        pts[e.pointerId] = { x: e.clientX, y: e.clientY };
        moved = false;
        start = { x: e.clientX, y: e.clientY, ox: self.x, oy: self.y, scale: self.scale, d: Object.keys(pts).length === 2 ? dist() : 0 };
        self.img() && self.img().classList.add('is-dragging');
      });
      stage.addEventListener('pointermove', function (e) {
        if (!pts[e.pointerId] || !start) return;
        pts[e.pointerId] = { x: e.clientX, y: e.clientY };
        var n = Object.keys(pts).length;
        if (n === 2) {
          if (!start.d) { start.d = dist(); start.scale = self.scale; }
          self.scale = Math.min(4, Math.max(1, start.scale * dist() / start.d));
          moved = true; self.apply(); return;
        }
        var dx = e.clientX - start.x, dy = e.clientY - start.y;
        if (Math.abs(dx) + Math.abs(dy) > 6) moved = true;
        if (self.scale > 1) { self.x = start.ox + dx; self.y = start.oy + dy; self.apply(); }
        else if (e.pointerType === 'mouse') { /* nessun trascinamento a zoom 1 */ }
        else { self.track.style.transform = 'translateX(calc(' + (-self.i * 100) + '% + ' + dx + 'px))'; self.track.style.transition = 'none'; }
      });
      var end = function (e) {
        if (!pts[e.pointerId]) return;
        var n = Object.keys(pts).length;
        delete pts[e.pointerId];
        self.img() && self.img().classList.remove('is-dragging');
        if (n > 1) { start = null; return; }
        var dx = e.clientX - (start ? start.x : e.clientX);
        self.track.style.transition = '';
        if (self.scale === 1 && moved && Math.abs(dx) > 50 && e.pointerType !== 'mouse') { self.go(self.i + (dx < 0 ? 1 : -1)); start = null; return; }
        if (self.scale === 1 && moved) { self.go(self.i); start = null; return; }
        if (!moved && !e.target.closest('button')) {
          var now = Date.now();
          if (e.pointerType === 'mouse' || now - lastTap < 300) { self.toggleZoom(e.clientX, e.clientY); lastTap = 0; }
          else lastTap = now;
        }
        if (self.scale > 1) self.clamp();
        start = null;
      };
      stage.addEventListener('pointerup', end);
      stage.addEventListener('pointercancel', end);
      // con il mouse, a zoom attivo l'immagine segue il cursore
      stage.addEventListener('mousemove', function (e) {
        if (self.scale <= 1 || Object.keys(pts).length) return;
        var r = stage.getBoundingClientRect(), img = self.img(); if (!img) return;
        var w = img.offsetWidth * self.scale, h = img.offsetHeight * self.scale;
        self.x = Math.max(0, (w - r.width) / 2) * (1 - 2 * (e.clientX - r.left) / r.width);
        self.y = Math.max(0, (h - r.height) / 2) * (1 - 2 * (e.clientY - r.top) / r.height);
        self.apply(true);
      });
      stage.addEventListener('wheel', function (e) {
        if (!e.ctrlKey && Math.abs(e.deltaY) < 1) return;
        e.preventDefault();
        self.scale = Math.min(4, Math.max(1, self.scale * (e.deltaY < 0 ? 1.12 : 0.89)));
        if (self.scale === 1) { self.x = self.y = 0; }
        self.apply(); self.el.classList.toggle('is-zoomed', self.scale > 1);
      }, { passive: false });
      return true;
    },
    img: function () { return this.track && this.track.children[this.i] && this.track.children[this.i].querySelector('img'); },
    apply: function (fast) {
      var img = this.img(); if (!img) return;
      img.style.transition = fast ? 'transform .12s linear' : '';
      img.style.transform = 'translate(' + this.x + 'px,' + this.y + 'px) scale(' + this.scale + ')';
    },
    clamp: function () {
      var img = this.img(), r = this.el.getBoundingClientRect(); if (!img) return;
      var mx = Math.max(0, (img.offsetWidth * this.scale - r.width) / 2), my = Math.max(0, (img.offsetHeight * this.scale - r.height) / 2);
      this.x = Math.max(-mx, Math.min(mx, this.x)); this.y = Math.max(-my, Math.min(my, this.y)); this.apply();
    },
    toggleZoom: function (cx, cy) {
      var img = this.img(); if (!img) return;
      if (this.scale > 1) { this.scale = 1; this.x = this.y = 0; }
      else {
        var r = img.getBoundingClientRect();
        this.scale = 2.5;
        this.x = (r.left + r.width / 2 - cx) * (this.scale - 1);
        this.y = (r.top + r.height / 2 - cy) * (this.scale - 1);
      }
      this.el.classList.toggle('is-zoomed', this.scale > 1);
      this.apply(); if (this.scale > 1) this.clamp();
    },
    open: function (srcs, i, thumbs) {
      if (!this.init()) return;
      var self = this;
      this.srcs = srcs;
      this.track.innerHTML = srcs.map(function (s) { return '<div class="lightbox__slide"><img src="' + s + '" alt="" draggable="false"></div>'; }).join('');
      var th = $('[data-lb-thumbs]', this.el);
      th.innerHTML = srcs.length > 1 ? (thumbs || srcs).map(function (s, k) { return '<button type="button" data-lb-thumb="' + k + '"><img src="' + s + '" alt=""></button>'; }).join('') : '';
      this.el.classList.toggle('is-single', srcs.length < 2);
      this.el.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      this.go(i, true);
      requestAnimationFrame(function () { self.el.classList.add('is-open'); });
    },
    go: function (i, instant) {
      var n = this.srcs.length; if (!n) return;
      var prev = this.img();
      if (prev) { prev.style.transform = ''; }
      this.i = (i + n) % n; this.scale = 1; this.x = this.y = 0;
      this.el.classList.remove('is-zoomed');
      this.track.style.transition = instant ? 'none' : '';
      this.track.style.transform = 'translateX(' + (-this.i * 100) + '%)';
      $('[data-lb-count]', this.el).textContent = n > 1 ? (this.i + 1) + ' / ' + n : '';
      var k = this.i;
      $$('[data-lb-thumb]', this.el).forEach(function (b, j) { b.classList.toggle('is-active', j === k); });
    },
    close: function () {
      var el = this.el; if (!el) return;
      el.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(function () { el.hidden = true; }, 350);
    }
  };

  /* ------------------------------------------------------------------
     Selettore varianti
  ------------------------------------------------------------------ */
  var VariantPicker = function () { return Reflect.construct(HTMLElement, [], VariantPicker); };
  VariantPicker.prototype = Object.create(HTMLElement.prototype);
  VariantPicker.prototype.connectedCallback = function () {
    var self = this;
    var data = $('[data-variants]', this);
    this.variants = data ? JSON.parse(data.textContent) : [];
    this.page = this.closest('product-page');
    this.addEventListener('change', function () { self.update(); });
  };
  VariantPicker.prototype.selected = function () {
    var out = [];
    $$('[data-option-index]', this).forEach(function (el) {
      var i = parseInt(el.getAttribute('data-option-index'), 10);
      if (el.tagName === 'SELECT') out[i] = el.value;
      else if (el.checked) out[i] = el.value;
    });
    return out;
  };
  VariantPicker.prototype.update = function () {
    var opts = this.selected();
    $$('[data-opt-value]', this).forEach(function (s) { s.textContent = opts[parseInt(s.getAttribute('data-opt-value'), 10)]; });
    var v = this.variants.filter(function (x) {
      return x.options.every(function (o, i) { return o === opts[i]; });
    })[0];
    var page = this.page;
    var btn = page && page.querySelector('[data-add-button]');
    if (!v) {
      if (btn) { btn.disabled = true; btn.querySelector('span').textContent = QS.strings.unavailable; }
      return;
    }
    $$('[data-variant-id]', page).forEach(function (i) { i.value = v.id; });
    $$('.product__installments input[name="id"]', page).forEach(function (i) { i.value = v.id; i.dispatchEvent(new Event('change', { bubbles: true })); });
    if (v.featured_media) {
      var g = page.querySelector('media-gallery');
      if (g) g.show(String(v.featured_media.id));
    }
    var url = page.getAttribute('data-url') + '?variant=' + v.id;
    try { window.history.replaceState({}, '', url); } catch (e) {}
    fetch(url + '&section_id=' + this.getAttribute('data-section'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = parseHTML(html);
        $$('[data-swap]', page).forEach(function (el) {
          var key = el.getAttribute('data-swap');
          var next = doc.querySelector('[data-swap="' + key + '"]');
          if (next) el.innerHTML = next.innerHTML;
          if (key === 'pickup' && el.loadFor) el.loadFor(v.id);
        });
      });
  };
  Object.setPrototypeOf(VariantPicker, HTMLElement);
  if (!customElements.get('variant-picker')) customElements.define('variant-picker', VariantPicker);

  /* Piramide olfattiva: completa famiglia, intensità, stagione e momento dal file del Fragrance Finder */
  var olfData = null;
  var OlfNotes = function () { return Reflect.construct(HTMLElement, [], OlfNotes); };
  OlfNotes.prototype = Object.create(HTMLElement.prototype);
  OlfNotes.prototype.connectedCallback = function () {
    var self = this, src = this.getAttribute('data-src');
    if (!src) return;
    var labels = {}; try { labels = JSON.parse(this.getAttribute('data-labels') || '{}'); } catch (e) {}
    olfData = olfData || fetch(src).then(function (r) { return r.ok ? r.json() : []; }).catch(function () { return []; });
    olfData.then(function (list) {
      var h = self.getAttribute('data-handle');
      var it = (list || []).filter(function (x) { return x.h === h; })[0];
      if (!it) return;
      var any = false;
      var fam = $('[data-olf-family]', self);
      if (fam && it.fam) { fam.textContent = it.fam; fam.hidden = false; }
      var inten = $('[data-olf-intensity]', self);
      if (inten && it.i) {
        var max = 3, html = '';
        for (var k = 1; k <= max; k++) html += '<i class="' + (k <= it.i ? 'on' : '') + '"></i>';
        $('.olf__dots', inten).innerHTML = html; inten.hidden = false; any = true;
        inten.setAttribute('aria-label', it.i + '/' + max);
      }
      var sea = $('[data-olf-season]', self);
      if (sea && it.se && it.se.length) {
        var order = ['P', 'E', 'A', 'I'];
        $('span', sea).textContent = order.filter(function (c) { return it.se.indexOf(c) > -1; }).map(function (c) { return labels[c] || c; }).join(' · ');
        sea.hidden = false; any = true;
      }
      var mom = $('[data-olf-moment]', self);
      if (mom && it.m) { $('span', mom).textContent = labels[it.m] || it.m; mom.hidden = false; any = true; }
      var facts = $('[data-olf-facts]', self);
      if (facts && any) facts.hidden = false;
      self.classList.add('is-complete');
    });
  };
  Object.setPrototypeOf(OlfNotes, HTMLElement);
  if (!customElements.get('olfactory-notes')) customElements.define('olfactory-notes', OlfNotes);

  /* Disponibilità ritiro in negozio */
  var Pickup = function () { return Reflect.construct(HTMLElement, [], Pickup); };
  Pickup.prototype = Object.create(HTMLElement.prototype);
  Pickup.prototype.connectedCallback = function () { this.loadFor(this.getAttribute('data-variant')); };
  Pickup.prototype.loadFor = function (id) {
    var self = this;
    fetch((this.getAttribute('data-root') || root) + 'variants/' + id + '/?section_id=pickup-availability')
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) { self.innerHTML = html ? sectionInner(html).innerHTML : ''; })
      .catch(function () { self.innerHTML = ''; });
  };
  Object.setPrototypeOf(Pickup, HTMLElement);
  if (!customElements.get('pickup-availability')) customElements.define('pickup-availability', Pickup);

  /* Contenuti caricati in differita (consigliati, complementari) */
  function lazyFetchElement(tag) {
    var El = function () { return Reflect.construct(HTMLElement, [], El); };
    El.prototype = Object.create(HTMLElement.prototype);
    El.prototype.connectedCallback = function () {
      var self = this;
      if (!this.dataset.url) return;
      var load = function () {
        fetch(self.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
          var fresh = sectionInner(html).querySelector(tag);
          if (fresh && fresh.innerHTML.trim()) self.innerHTML = fresh.innerHTML;
        });
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '0px 0px 400px 0px' });
        io.observe(this);
      } else load();
    };
    Object.setPrototypeOf(El, HTMLElement);
    if (!customElements.get(tag)) customElements.define(tag, El);
  }
  lazyFetchElement('product-recs');
  lazyFetchElement('product-complementary');

  /* Visti di recente */
  (function () {
    var page = $('product-page');
    var key = 'qs-recent';
    var list = [];
    try { list = JSON.parse(store.get(key) || '[]'); } catch (e) { list = []; }
    var section = $('recently-viewed');
    if (section) {
      var current = section.getAttribute('data-current');
      var limit = parseInt(section.getAttribute('data-limit'), 10) || 5;
      var handles = list.filter(function (h) { return h !== current; }).slice(0, limit);
      if (handles.length) {
        var ul = $('[data-recent-list]', section);
        Promise.all(handles.map(function (h) {
          return fetch(root + 'products/' + h + '?view=qs-card').then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
        })).then(function (parts) {
          var html = parts.join('');
          if (html.trim()) { ul.innerHTML = html; section.hidden = false; }
        });
      }
    }
    if (page) {
      var handle = (page.getAttribute('data-url') || '').split('/').pop();
      if (handle) {
        list = [handle].concat(list.filter(function (h) { return h !== handle; })).slice(0, 12);
        store.set(key, JSON.stringify(list));
      }
    }
  })();

  /* ------------------------------------------------------------------
     Filtri collezione / ricerca
  ------------------------------------------------------------------ */
  (function () {
    var wrap = $('[data-collection]');
    if (!wrap) return;
    var sectionId = wrap.getAttribute('data-section');
    var load = function (url, push) {
      var grid = $('[data-swap-coll="grid"]', wrap);
      if (grid) grid.classList.add('is-loading');
      var sep = url.indexOf('?') > -1 ? '&' : '?';
      fetch(url + sep + 'section_id=' + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = parseHTML(html);
          $$('[data-swap-coll]', wrap).forEach(function (el) {
            var next = doc.querySelector('[data-swap-coll="' + el.getAttribute('data-swap-coll') + '"]');
            if (next) el.innerHTML = next.innerHTML;
          });
          if (push) window.history.pushState({ facets: true }, '', url);
        })
        .finally(function () { var g = $('[data-swap-coll="grid"]', wrap); if (g) g.classList.remove('is-loading'); });
    };
    var fromForm = function () {
      var form = $('[data-facets-form]', wrap);
      var params = new URLSearchParams(form ? new FormData(form) : undefined);
      var sort = $('select[name="sort_by"]', wrap);
      if (sort) params.set('sort_by', sort.value);
      Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '') params.delete(k); });
      load(window.location.pathname + '?' + params.toString(), true);
    };
    var deb = debounce(fromForm, 600);
    wrap.addEventListener('change', function (e) {
      if (!e.target.matches('[data-facet-input]')) return;
      if (e.target.hasAttribute('data-debounce')) deb(); else fromForm();
    });
    wrap.addEventListener('submit', function (e) { if (e.target.matches('[data-facets-form]')) { e.preventDefault(); fromForm(); } });
    wrap.addEventListener('click', function (e) {
      var a = e.target.closest('[data-facet-link]');
      if (a) { e.preventDefault(); load(a.getAttribute('href'), true); }
    });
    window.addEventListener('popstate', function (e) { if (e.state && e.state.facets) load(window.location.href, false); });
  })();

  /* ------------------------------------------------------------------
     Popup newsletter e verifica età
  ------------------------------------------------------------------ */
  var NlPopup = function () { return Reflect.construct(HTMLElement, [], NlPopup); };
  NlPopup.prototype = Object.create(HTMLElement.prototype);
  NlPopup.prototype.connectedCallback = function () {
    var self = this;
    var id = 'qs-popup-' + this.dataset.id;
    var reminder = document.querySelector('[data-popup-reminder]');
    var test = this.dataset.test === 'true';
    var success = this.querySelector('[data-nl-success]');
    if (this.hasAttribute('data-editor') && !test) return;
    var last = parseInt(store.get(id) || '0', 10);
    var days = parseInt(this.dataset.days, 10) || 5;
    var expired = Date.now() - last > days * 864e5;
    if (success) { store.set(id, String(Date.now() + 365 * 864e5)); this.open(); return; }
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    var pillMode = !!reminder && (mobile ? this.dataset.modeMobile : this.dataset.modeDesktop) === 'pill';
    var delayMs = (parseInt(this.dataset.delay, 10) || 5) * 1000;
    if (pillMode) {
      // Modalità linguetta: niente apertura automatica, solo la pill in basso
      if (test || store.get(id + '-reminder-off') !== '1') {
        setTimeout(function () { if (self.hidden) reminder.hidden = false; }, expired || test ? delayMs : 0);
      }
    } else {
      if (store.get(id + '-reminder-off') !== '1' && !expired && reminder) reminder.hidden = false;
      if (test || expired) {
        setTimeout(function () { self.open(); }, delayMs);
      }
    }
    this.addEventListener('click', function (e) {
      if (e.target === self || e.target.closest('[data-popup-close]')) self.close(id, reminder);
    });
    if (reminder) {
      reminder.addEventListener('click', function (e) {
        if (e.target.closest('[data-reminder-dismiss]')) { reminder.hidden = true; store.set(id + '-reminder-off', '1'); return; }
        self.open();
      });
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !self.hidden) self.close(id, reminder); });
  };
  NlPopup.prototype.open = function () {
    var self = this;
    this.hidden = false;
    requestAnimationFrame(function () { self.classList.add('is-open'); });
    var r = document.querySelector('[data-popup-reminder]');
    if (r) r.hidden = true;
  };
  NlPopup.prototype.close = function (id, reminder) {
    var self = this;
    this.classList.remove('is-open');
    setTimeout(function () { self.hidden = true; }, 300);
    store.set(id, String(Date.now()));
    if (reminder && store.get(id + '-reminder-off') !== '1') reminder.hidden = false;
  };
  Object.setPrototypeOf(NlPopup, HTMLElement);
  if (!customElements.get('newsletter-popup')) customElements.define('newsletter-popup', NlPopup);
  document.addEventListener('shopify:section:select', function (e) {
    var p = e.target.querySelector('newsletter-popup');
    if (p) p.open();
    var a = e.target.querySelector('age-gate');
    if (a) a.hidden = false;
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var p = e.target.querySelector('newsletter-popup');
    if (p) { p.classList.remove('is-open'); p.hidden = true; }
    var a = e.target.querySelector('age-gate');
    if (a) a.hidden = true;
  });

  var AgeGate = function () { return Reflect.construct(HTMLElement, [], AgeGate); };
  AgeGate.prototype = Object.create(HTMLElement.prototype);
  AgeGate.prototype.connectedCallback = function () {
    var self = this;
    if (this.hasAttribute('data-editor') && this.dataset.test !== 'true') return;
    if (store.get('qs-age-ok') === '1' && this.dataset.test !== 'true') return;
    this.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    this.addEventListener('click', function (e) {
      var b = e.target.closest('[data-age]');
      if (!b) return;
      var v = b.getAttribute('data-age');
      var ask = self.querySelector('[data-step="ask"]');
      var den = self.querySelector('[data-step="denied"]');
      if (v === 'yes') { store.set('qs-age-ok', '1'); self.hidden = true; document.documentElement.style.overflow = ''; }
      if (v === 'no') { ask.hidden = true; den.hidden = false; }
      if (v === 'back') { ask.hidden = false; den.hidden = true; }
    });
  };
  Object.setPrototypeOf(AgeGate, HTMLElement);
  if (!customElements.get('age-gate')) customElements.define('age-gate', AgeGate);

  /* ------------------------------------------------------------------
     Recensioni Google (Maps JavaScript API - Places)
  ------------------------------------------------------------------ */
  var gmapsLoading = null;
  var loadGoogleMaps = function (key, lang) {
    if (window.google && window.google.maps && window.google.maps.importLibrary) return Promise.resolve();
    if (gmapsLoading) return gmapsLoading;
    gmapsLoading = new Promise(function (resolve, reject) {
      var cb = '__qsGmaps' + Date.now();
      window[cb] = function () { resolve(); };
      var sc = document.createElement('script');
      sc.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) + '&v=weekly&loading=async&language=' + encodeURIComponent(lang) + '&callback=' + cb;
      sc.async = true;
      sc.onerror = reject;
      document.head.appendChild(sc);
    });
    return gmapsLoading;
  };
  var esc = function (t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; };
  var starsHTML = function (r) {
    var out = '';
    for (var i = 1; i <= 5; i++) {
      var fill = Math.max(0, Math.min(1, r - i + 1));
      out += '<span class="gr-star" style="--f:' + Math.round(fill * 100) + '%"></span>';
    }
    return out;
  };
  var GoogleReviews = function () { return Reflect.construct(HTMLElement, [], GoogleReviews); };
  GoogleReviews.prototype = Object.create(HTMLElement.prototype);
  GoogleReviews.prototype.connectedCallback = function () {
    var self = this;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { io.disconnect(); self.load(); }
      }, { rootMargin: '400px 0px' });
      io.observe(this.parentElement || this);
    } else { this.load(); }
  };
  GoogleReviews.prototype.load = function () {
    var self = this, d = this.dataset;
    var ck = 'qs-greviews-' + d.place + '-' + d.lang;
    var cached = null;
    try { cached = JSON.parse(store.get(ck) || 'null'); } catch (e) {}
    if (cached && Date.now() - cached.t < (parseFloat(d.cache) || 12) * 36e5) { this.render(cached.data); return; }
    loadGoogleMaps(d.key, d.lang).then(function () {
      return google.maps.importLibrary('places');
    }).then(function (lib) {
      var place = new lib.Place({ id: d.place, requestedLanguage: d.lang });
      return place.fetchFields({ fields: ['displayName', 'rating', 'userRatingCount', 'reviews', 'googleMapsURI'] }).then(function () { return place; });
    }).then(function (place) {
      var data = {
        rating: place.rating, count: place.userRatingCount, url: place.googleMapsURI,
        reviews: (place.reviews || []).map(function (r) {
          var a = r.authorAttribution || {};
          return { rating: r.rating, text: r.text || '', when: r.relativePublishTimeDescription || '', author: a.displayName || '', photo: a.photoURI || '', authorUrl: a.uri || '' };
        })
      };
      store.set(ck, JSON.stringify({ t: Date.now(), data: data }));
      self.render(data);
    }).catch(function (e) {
      if (window.console) console.warn('[Recensioni Google]', e && e.message ? e.message : e);
    });
  };
  GoogleReviews.prototype.render = function (data) {
    var d = this.dataset, L = {};
    try { L = JSON.parse(d.labels); } catch (e) {}
    var min = parseFloat(d.min) || 1, max = parseInt(d.max, 10) || 5;
    var list = (data.reviews || []).filter(function (r) { return r.rating >= min && r.text; }).slice(0, max);
    if (!data.rating && !list.length) return;
    var score = $('[data-gr-score]', this), st = $('[data-gr-stars]', this), cnt = $('[data-gr-count]', this), link = $('[data-gr-link]', this);
    if (score) score.textContent = (Math.round(data.rating * 10) / 10).toLocaleString(d.lang, { minimumFractionDigits: 1 });
    if (st) st.innerHTML = starsHTML(data.rating || 0);
    if (cnt) cnt.textContent = (L.based || '%n').replace('%n', (data.count || 0).toLocaleString(d.lang));
    if (link) { if (data.url) link.href = data.url; else link.remove(); }
    $('[data-gr-list]', this).innerHTML = list.map(function (r) {
      var initial = esc((r.author || '?').trim().charAt(0).toUpperCase());
      var avatar = r.photo ? '<img src="' + esc(r.photo) + '" alt="" width="40" height="40" loading="lazy" referrerpolicy="no-referrer">' : '<span>' + initial + '</span>';
      var name = r.authorUrl ? '<a href="' + esc(r.authorUrl) + '" target="_blank" rel="noopener">' + esc(r.author) + '</a>' : esc(r.author);
      return '<article class="gr-card" role="listitem">' +
        '<div class="gr-card__stars" aria-label="' + r.rating + '/5">' + starsHTML(r.rating) + '</div>' +
        '<div class="gr-card__text"><p>' + esc(r.text).replace(/\n+/g, '</p><p>') + '</p></div>' +
        '<button type="button" class="gr-card__more" hidden>' + esc(L.more || 'Leggi tutto') + '</button>' +
        '<div class="gr-card__author"><span class="gr-card__avatar">' + avatar + '</span><span><strong>' + name + '</strong><small>' + esc(r.when) + '</small></span></div>' +
      '</article>';
    }).join('');
    this.hidden = false;
    $$('.gr-card', this).forEach(function (card) {
      var txt = $('.gr-card__text', card), btn = $('.gr-card__more', card);
      if (txt.scrollHeight > txt.clientHeight + 4) {
        btn.hidden = false;
        btn.addEventListener('click', function () {
          var open = card.classList.toggle('is-open');
          btn.textContent = open ? (L.less || 'Mostra meno') : (L.more || 'Leggi tutto');
        });
      }
    });
  };
  Object.setPrototypeOf(GoogleReviews, HTMLElement);
  if (!customElements.get('google-reviews')) customElements.define('google-reviews', GoogleReviews);

  /* ------------------------------------------------------------------
     Varie: barra annunci, condivisione, login, comparsa
  ------------------------------------------------------------------ */
  $$('[data-rotator]').forEach(function (bar) {
    var items = $$('.announce__item', bar);
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, (parseInt(bar.dataset.speed, 10) || 5) * 1000);
  });

  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-copy-url]');
    if (c && navigator.clipboard) {
      navigator.clipboard.writeText(c.getAttribute('data-copy-url')).then(function () {
        var l = c.querySelector('[data-copy-label]');
        if (l) { var t = l.textContent; l.textContent = '✓'; setTimeout(function () { l.textContent = t; }, 1600); }
      });
    }
    var rec = e.target.closest('[data-toggle-recover]');
    if (rec) {
      e.preventDefault();
      var a = $('[data-login-panel]'), b = $('[data-recover-panel]');
      if (a && b) { a.hidden = !a.hidden; b.hidden = !b.hidden; }
    }
  });
  if (window.location.hash === '#recover') {
    var lp = $('[data-login-panel]'), rp = $('[data-recover-panel]');
    if (lp && rp) { lp.hidden = true; rp.hidden = false; }
  }
  $$('[data-gc-offset]').forEach(function (i) { i.value = new Date().getTimezoneOffset(); });

  // barra di acquisto fissa su mobile: compare quando il pulsante principale esce dallo schermo
  (function () {
    var bar = $('[data-sticky-atc]');
    var main = $('[data-swap="buttons"]');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    var footer = $('.site-footer');
    var mainVisible = true, footerVisible = false;
    var update = function () { var on = !mainVisible && !footerVisible; bar.classList.toggle('is-visible', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true'); $('[data-sticky-atc-btn]', bar).tabIndex = on ? 0 : -1; };
    new IntersectionObserver(function (e) { mainVisible = e[0].isIntersecting || e[0].boundingClientRect.top > window.innerHeight; update(); }).observe(main);
    if (footer) new IntersectionObserver(function (e) { footerVisible = e[0].isIntersecting; update(); }).observe(footer);
    bar.addEventListener('click', function (e) {
      if (!e.target.closest('[data-sticky-atc-btn]')) return;
      var form = $('[data-product-form]');
      if (form) { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
    });
    // mantiene il pulsante della barra allineato alla variante scelta
    new MutationObserver(function () {
      var b = $('[data-sticky-atc-btn]', bar);
      var src = $('[data-add-button]', main);
      if (!src) return;
      b.disabled = src.disabled;
      b.textContent = src.textContent.trim();
    }).observe(main, { attributes: true, childList: true, subtree: true, characterData: true });
  })();

  // footer: su mobile i menu partono chiusi (a fisarmonica)
  if (window.matchMedia('(max-width: 749px)').matches) {
    $$('.footer-acc[open]').forEach(function (d) { d.removeAttribute('open'); });
  }

  // animazioni di comparsa allo scorrimento
  if (document.body.classList.contains('has-anim') && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
    var mark = function (el, type, i) {
      if (el.hasAttribute('data-anim') || el.closest('[data-first-section]')) return;
      el.setAttribute('data-anim', type || '');
      if (i != null) el.style.setProperty('--i', i);
      io.observe(el);
    };
    var scan = function (scope) {
      $$('.shopify-section', scope).forEach(function (sec, n) {
        if (sec.closest('#MainContent') === null) return;
        if (sec.querySelector('[data-first-section]') || sec.querySelector('.qf')) return;
        $$('.section-title, .hotspots__title, .iwt__text h2, .ibanner__box h2, .map-block__text h2, .cc-text h2, .cc-html h2', sec).forEach(function (t) { mark(t, 'title'); });
        $$('.banner__media, .iwt__img, .ibanner__media, .hotspots__media, .cc-item:has(.cc-img), .tcol__img, .article__hero', sec).forEach(function (m) { mark(m, 'img'); });
        $$('.grid, .tiles, .subcols, .icon-cols, .svc__grid, .tcols, .testimonials__row, .articles, .logos', sec).forEach(function (list) {
          Array.prototype.forEach.call(list.children, function (c, k) { mark(c, 'up', k % 6); });
        });
        $$('.banner__text, .svc__head, .iwt__text > *, .rt-block, .cc-text, .cc-html, .ibanner__box, .collapsible, .faq__group, .section-head .link-underline', sec).forEach(function (b, k) { mark(b, 'up', k % 4); });
      });
    };
    if (!(window.Shopify && window.Shopify.designMode)) scan(document);
    // nuovi elementi caricati dopo (consigliati, visti di recente, filtri)
    if (window.MutationObserver && !(window.Shopify && window.Shopify.designMode)) {
      var pending;
      new MutationObserver(function () { clearTimeout(pending); pending = setTimeout(function () { scan(document); }, 60); })
        .observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
    }
  }
})();
